import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ImpersonationData } from 'src/app/shared/models/user-model';
import { FlexyooLetDirective } from '@flexyoo/shared/directives';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-impersonated-banner',
  templateUrl: './impersonated-banner.component.html',
  styleUrls: ['./impersonated-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FlexyooLetDirective, TranslateModule, MatTooltip],
})
export class ImpersonatedBannerComponent {
  @Input() public userName: string;
  @Input() public tenantName: string;
  @Input() public impersonation: ImpersonationData;

  @Input() public isBannerView = false;

  @Output() public readonly close = new EventEmitter<void>();
}
